import { Collection } from "@/api";
import { TEMPLATE_WEBSITE, WORKOUT_TEMPLATES } from "@/const";

export const isCollectionOfCollections = (collection: Collection) => {
  const containsWorkoutOrCircuit = collection?.Items.some((i) =>
    WORKOUT_TEMPLATES.includes(i.TemplateId ?? ""),
  );

  if (containsWorkoutOrCircuit) {
    return false;
  }

  const containsWebsiteItem = collection?.Items.some(
    (i) => i.TemplateId === TEMPLATE_WEBSITE,
  );

  if (containsWebsiteItem) {
    return false;
  }

  // All are tab/collection items
  return !collection?.Items.some(
    (i) => !["collection", "tab"].includes(i.Type),
  );
};
